// extracted by mini-css-extract-plugin
module.exports = {"styledRow":"styles_styledRow__6T-Db","styledRow__header":"styles_styledRow__header__1Zq4v","styledRow__footer":"styles_styledRow__footer__31BNt"};